import { createSlice } from '@reduxjs/toolkit';

export const languageSlice = createSlice({
    name: 'language',
    initialState: {},
    reducers: {
        setPreferred: (state, action) => {
            state.preferred =
                state.available.find(
                    language => language.languageCodeIso2 === action.payload
                ) || {};
        },
        filterAvailableLanguages: (state, action) => {
            // Always show swedish, english, the language from the url, the language of the country the user is in, and
            // the language of the country of the member. This is temporary logic during initial internationalization.
            const gpsCountry = (action.payload.isoCode || '').toLowerCase();
            const memberCountry = (
                state.memberCountryCodeIso2 || ''
            ).toLowerCase();
            const urlLanguage = state.preferred.languageCodeIso2;
            const languagesToShow = {
                da: gpsCountry === 'dk' || memberCountry === 'dk',
                de: gpsCountry === 'de' || memberCountry === 'de',
                sv: true,
                en: true,
                [urlLanguage]: true
            };
            state.available = state.available.filter(
                ({ languageCodeIso2 }) =>
                    languagesToShow[languageCodeIso2] === true
            );
        }
    }
});

export const { setPreferred, filterAvailableLanguages } = languageSlice.actions;
export default languageSlice.reducer;
